"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tabs = void 0;
const react_1 = __importDefault(require("react"));
const styled_1 = require("./styled");
const alert_counter_1 = require("../../alert-counter");
const Tab = ({ count, isSelected, title, counterBackgroundColor = alert_counter_1.DEFAULT_COUNTER_BACKGROUND_COLOR, counterColor = alert_counter_1.DEFAULT_COUNTER_COLOR, onSelect }) => {
    return (react_1.default.createElement(styled_1.StyledTab, { role: "button", isSelected: isSelected, onClick: onSelect },
        title,
        react_1.default.createElement(styled_1.StyledCounter, { "$counterColor": counterColor, "$counterBackgroundColor": counterBackgroundColor }, (0, alert_counter_1.transformCounter)(count, 99))));
};
const notificationTabStyles = {
    counterColor: { color: 'onSurface' },
    counterBackgroundColor: { color: 'onSurface', shade: 'pressed' }
};
const Tabs = ({ selectedTab, onSelect, tabs }) => {
    return (react_1.default.createElement(styled_1.StyledTabWrapper, null, tabs.map((tab) => {
        const rest = tab.id === 'notification' ? notificationTabStyles : {};
        return (react_1.default.createElement(Tab, Object.assign({ key: tab.id, count: tab.totalCount, onSelect: () => onSelect(tab.id), title: tab.title, isSelected: selectedTab === tab.id }, rest)));
    })));
};
exports.Tabs = Tabs;
